__turbopack_context__.v({
  "anchor": "_8K67Xq_anchor",
  "chevron": "_8K67Xq_chevron",
  "description": "_8K67Xq_description",
  "field": "_8K67Xq_field",
  "footer": "_8K67Xq_footer",
  "label": "_8K67Xq_label",
  "part": "_8K67Xq_part",
  "partValue": "_8K67Xq_partValue",
  "placeholder": "_8K67Xq_placeholder",
  "popover": "_8K67Xq_popover",
  "srOnly": "_8K67Xq_srOnly",
  "status": "_8K67Xq_status",
  "trigger": "_8K67Xq_trigger",
  "value": "_8K67Xq_value",
  "valueText": "_8K67Xq_valueText",
});
